import styled from 'styled-components'

export const GeneratedImageContainer = styled.div`
  padding: 20px 0;
  width: 100%;
  display: flex;
  flex-direction: column;
`
